import { Button } from '@avanta/shared/components/ui/Button';
import { CircleCheck } from 'lucide-react';
import { type ReactElement } from 'react';
import { useSurveyContext } from 'contexts/Survey';
import { type EndCardProps } from './types';

export const EndCard = ({
  title = '',
  subtitle = '',
  allowRepeat = false,
  repeatButton,
  children,
}: EndCardProps): ReactElement => {
  const { handleRepeat } = useSurveyContext();

  const showRepeatButton = allowRepeat && repeatButton;

  return (
    <div className="flex flex-col gap-8 w-full">
      <div className="flex flex-col gap-4 justify-center items-center">
        <CircleCheck className="size-18 text-teal-600" />
        <div className="flex flex-col gap-2 text-center">
          <h2 className="text-xl font-semibold">{title}</h2>
          <p className="text-sm text-gray-600">{subtitle}</p>
        </div>
      </div>
      {children}
      {showRepeatButton && (
        <div className="flex justify-center mt-4">
          <Button size="lg" onClick={handleRepeat} className="w-fit">
            {repeatButton}
          </Button>
        </div>
      )}
    </div>
  );
};
